import { render, staticRenderFns } from "./TeacherDetails.vue?vue&type=template&id=50dd6f0e&scoped=true&"
import script from "./TeacherDetails.vue?vue&type=script&lang=js&"
export * from "./TeacherDetails.vue?vue&type=script&lang=js&"
import style0 from "./TeacherDetails.vue?vue&type=style&index=0&id=50dd6f0e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50dd6f0e",
  null
  
)

export default component.exports